import script from "./ProspectusFooterEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspectusFooterEditor.vue?vue&type=script&setup=true&lang=js"

import "./ProspectusFooterEditor.vue?vue&type=style&index=0&id=42d1bd58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d1bd58"]])

export default __exports__